import { render } from "./policyDetail.vue?vue&type=template&id=984d4a0e"
import script from "./policyDetail.vue?vue&type=script&lang=js"
export * from "./policyDetail.vue?vue&type=script&lang=js"

import "./policyDetail.vue?vue&type=style&index=0&id=984d4a0e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__